import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';


export type CreateContactPayload = {
  contacts: {
    name: string;
    phone: string;
    tags: string[];
    notes: string;
    metadata: Record<string, string>;
  }[]
};

type MutationResponse = {
  timestamp: string;
  statusCode: number;
  status: string;
  message: string;
  data: any;
};

export const useCreateContactMutation = () => {
  const mutationFn = useGetMutationFn<CreateContactPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while creating WhatsApp Contact',
    endpoint: '/api/admin/whatsapp/contacts/bulk',
    method: 'POST',
  });
  return useMutation<MutationResponse, Error, CreateContactPayload>({ mutationFn });
};
